import { useApp } from '../context/AppContext';
import { useI18n } from '../context/I18nContext';

export default function CharterModal() {
  const { setShowCharter } = useApp();
  const { t } = useI18n();

  return (
    <div className="modal-overlay show" onClick={e => e.target === e.currentTarget && setShowCharter(false)}>
      <div className="modal modal-wide">
        <div className="modal-header">
          <h2>📜 {t('charterTitle')}</h2>
          <button className="modal-close" onClick={() => setShowCharter(false)}>&times;</button>
        </div>
        <div className="modal-body charter-body">
          <div className="charter-quote">
            <strong>{t('charterVersion')}</strong> — {t('charterEffective')}
          </div>

          <section className="charter-section">
            <h3 className="charter-heading">1. {t('charterArt1Title')}</h3>
            <p>{t('charterArt1Text')}</p>
          </section>

          <section className="charter-section">
            <h3 className="charter-heading">2. {t('charterArt2Title')}</h3>
            <p>{t('charterArt2Intro')}</p>
            <ul className="charter-list">
              <li>{t('charterArt2Item1')}</li>
              <li>{t('charterArt2Item2')}</li>
              <li>{t('charterArt2Item3')}</li>
              <li>{t('charterArt2Item4')}</li>
            </ul>
          </section>

          <section className="charter-section">
            <h3 className="charter-heading">3. {t('charterArt3Title')}</h3>
            <p className="charter-warning">{t('charterArt3Intro')}</p>
            <ul className="charter-list">
              <li>{t('charterArt3Item1')}</li>
              <li>{t('charterArt3Item2')}</li>
            </ul>
          </section>

          <section className="charter-section">
            <h3 className="charter-heading">4. {t('charterArt4Title')}</h3>
            <h4 className="charter-subheading">4.1 {t('charterArt4_1Title')}</h4>
            <p>{t('charterArt4_1Text')}</p>
            <h4 className="charter-subheading">4.2 {t('charterArt4_2Title')}</h4>
            <ol className="charter-list">
              <li>{t('charterArt4_2Item1')}</li>
              <li>{t('charterArt4_2Item2')}</li>
            </ol>
            <h4 className="charter-subheading">4.3 {t('charterArt4_3Title')}</h4>
            <p>{t('charterArt4_3Text')}</p>
          </section>

          <section className="charter-section">
            <h3 className="charter-heading">5. {t('charterArt5Title')}</h3>
            <ul className="charter-list">
              <li>{t('charterArt5Item1')}</li>
              <li>{t('charterArt5Item2')}</li>
              <li>{t('charterArt5Item3')}</li>
            </ul>
          </section>

          <section className="charter-section">
            <h3 className="charter-heading">6. {t('charterArt6Title')}</h3>
            <p>{t('charterArt6Text')}</p>
          </section>

          <footer className="charter-footer">
            <em>Synaptics Solutions &amp; Technologies Ltd — Cogency AI</em>
          </footer>
        </div>
      </div>
    </div>
  );
}
